import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import ImportExportService from './service'

export const getImportExportData = createAsyncThunk(
  'companyAnalysis/industryOverview/macroeconomics/importExport/getImportExportData',
  async (params, { rejectWithValue }) => {
    try {
      const res = await ImportExportService.getImportExportData(params)

      return res.success ? res.data : rejectWithValue({ isLoading: false })
    } catch (error) {
      return rejectWithValue({ isLoading: axios.isCancel(error) })
    }
  },
)
